import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from 'yup';
import { useToast } from "../../../Hooks/ToasContext";
import { ICategoryEntity, ICreateCategoryPayload,  } from "../../../Services/api/categories/categories.interface";
import { CreateSellersUseCase } from "../../../Usecase/Sellers/create-sellers-usecase";
import { UpdateSellersUseCase } from "../../../Usecase/Sellers/update-sellers-usecase";
import { ICreateSellersPayload, ISellerEntity, IUpdateSellersPayload } from "../../../Services/api/sellers/sellers.interface";
import { ShowSellersUseCase } from "../../../Usecase/Sellers/show-sellers-usecase";


interface IUseCreateSellersProps {
    createSellersUseCase: CreateSellersUseCase
    updateSellersUseCase: UpdateSellersUseCase
    showSellersUseCase: ShowSellersUseCase
  
}

const CreateSellerSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    email: Yup.string().required('E-mail é obrigatório').email('E-mail inválido'),
  });


const storeTypeOptions = [
  { label: 'Cadastrar na EMPO - B2B', value: 'createOnNSEmpo' },
  { label: 'Cadastrar na EMPO - B2C', value: 'createOnNSPapello' },
];

interface ISellerProps {
    name: string
    email: string
}


export function useCreateSellers({ createSellersUseCase, updateSellersUseCase, showSellersUseCase }: IUseCreateSellersProps){
    const [loading, setLoading] = useState(false)
    
    const [lengthValue, setLenghValue] = useState(0);
    const [widthValue, setWidthValue] = useState(0)
    const [heightValue, setHeightValue] = useState(0)
    const [data, setData] = useState<ISellerEntity>()

    const params = useParams()
    
    const navigate = useNavigate()
    const { handleSubmit, register, control, formState, setValue } = useForm<ISellerProps>({
        resolver: yupResolver(CreateSellerSchemaValidation),
      });

      const { errors } =  formState

    const { showToast } =  useToast()

    const listSellers = async (sellerId: string) => {
        
        try {
          setLoading(true)
          
          const showResult = await showSellersUseCase.handle(sellerId);

          if (showResult.isFailure) {
            showToast(String(showResult?.error?.error), 'error');
            return;
          }

         const box = showResult.getValue()
         console.log("box: ", box)

         if(box){
      

            setValue('name', box.name || '')
            setValue('email', box.email || '')

            
         }

        } catch (error) {
          console.log("error listSellers function: ", error)
        } finally {
          setLoading(false);
        }
      };


    const handleAction: SubmitHandler<ISellerProps> = async (values) => {

        try {
          setLoading(true)

          const payloadCreate: ICreateSellersPayload  = {
            name: values.name,
            email: values.email
          }

          const payloadUpdate: IUpdateSellersPayload  = {
            ...values,
            id: String(params.id)
          }

        
          const storeResult = params.id ? await updateSellersUseCase.handle(payloadUpdate) :  await createSellersUseCase.handle(payloadCreate);

          if (storeResult.isFailure) {
            
            showToast(String(storeResult?.error?.error), 'error');
            return;
          }

          showToast(params.id ? 'Vendedor Atualizado' : 'Vendedor Cadastrado', 'success')
          navigate('/sellers-list');

        } catch (error) {
            console.log("error: ", error)
            showToast(error.response?.data?.error ?? 'Erro. Por favor, tente novamente', 'error');
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
        } finally {
          setLoading(false);
        }
      };

      console.log("params: ", params)

  
    useEffect(() => {
      if(params.id){
        listSellers(params.id)
      }
    },[params])

      

    return {
        loading,
        handleSubmit,
        handleAction,
        register,
        lengthValue,
        setLenghValue,
        widthValue,
        setWidthValue,
        heightValue,
        setHeightValue,
        errors,
        data,
        storeTypeOptions,
        control
        
        
    }
}